import jStat from 'jstat';

import * as base from './base';

const makePdFn = (df1, df2) => x =>
  jStat.centralF.pdf(x, df1, df2);

const makeInvFn = (df1, df2) => alpha =>
  jStat.centralF.inv(alpha, df1, df2);

const makeCdfFn = (df1, df2) => cutoff =>
  jStat.centralF.cdf(cutoff, df1, df2);

const getPds = (df1, df2) => {
  const xMin = 0;
  const xMax = df2;

  const pdFn = makePdFn(df1, df2);
  return base.getPds(xMin, xMax, pdFn);
};

const getCutoffsByAlpha = (df1, df2, alpha) => {
  const pdFn = makePdFn(df1, df2);
  const invFn = makeInvFn(df1, df2);

  return base.getCutoffsByAlpha(base.getMaxAlphaRange(alpha), pdFn, invFn);
};

const getAlphaByCutoffsAndTailType = (df1, df2, leftCutoffX, rightCutoffX, tailType) =>
  base.getAlphaByCutoffsAndTailType(makeCdfFn(df1, df2), leftCutoffX, rightCutoffX, tailType);

const getCutoffsByCutoffXValues = (df1, df2, leftCutoffValue, RightCutoffValue) => {
  const pdFn = makePdFn(df1, df2);

  return base.getCutoffsByCutoffXValues(pdFn, leftCutoffValue, RightCutoffValue);
};

const fisherDistributionFunctions = {
  getPds: ({ numeratorDf, denominatorDf }) => (
    getPds(+numeratorDf, +denominatorDf)
  ),

  getCutoffsByAlpha: ({ numeratorDf, denominatorDf }, alpha) => (
    getCutoffsByAlpha(+numeratorDf, +denominatorDf, +alpha)
  ),

  getAlphaByCutoffsAndTailType: ({ numeratorDf, denominatorDf }, leftCutoffX, rightCutoffX, tailType) => (
    getAlphaByCutoffsAndTailType(+numeratorDf, +denominatorDf, +leftCutoffX, +rightCutoffX, tailType)
  ),
  getCutoffsByCutoffXValues: ({ numeratorDf, denominatorDf }, leftCutoffValue, rightCutoffValue) => (
    getCutoffsByCutoffXValues(+numeratorDf, +denominatorDf, +leftCutoffValue, +rightCutoffValue)
  )
};

export default fisherDistributionFunctions;
